export const FETCH_REPORT_HISTORY = 'FETCH_REPORT_HISTORY';
export const FETCH_REPORT_HISTORY_SUCCESS = 'FETCH_REPORT_HISTORY_SUCCESS';
export const FETCH_REPORT_HISTORY_FAIL = 'FETCH_REPORT_HISTORY_FAIL';

export const fetchReportHistory = ({ reportId, currentHistoryPage }) => ({
  type: FETCH_REPORT_HISTORY,
  payload: { reportId, currentHistoryPage }
});

export const fetchReportHistorySuccess = ({ list, total }) => ({
  type: FETCH_REPORT_HISTORY_SUCCESS,
  payload: { list, total }
});

export const fetchReportHistoryFail = () => ({
  type: FETCH_REPORT_HISTORY_FAIL
});
